const PAUSE_TYPES = ['pause', 'paragraph_end', 'audio'];
const LIST_TYPE = 'list';
const LIST_INDENT_STEP = 16;

export const isPause = (part) => PAUSE_TYPES.includes(part.type_part.slug);

export const isListTextPart = (part) => {
    return (
        part &&
        part.type_text &&
        part.type_text.slug === LIST_TYPE &&
        part.type_part.slug === 'text'
    );
};

export const isListPausePart = (part) => {
    return (
        part &&
        part.type_text &&
        part.type_text.slug === LIST_TYPE &&
        part.type_part.slug === 'pause'
    );
};

export const isListPauseAfterListText = (prevPart, currentPart) => {
    return isListTextPart(prevPart) && isListPausePart(currentPart);
};

const getListItemKey = (part) => {
    if (!part || !part.type_text || part.type_text.slug !== LIST_TYPE) return null;
    if (typeof part.list_level !== 'number' || typeof part.list_item_index !== 'number')
        return null;

    return `${part.list_level}:${part.list_item_index}`;
};

export const groupListRenderItems = (bookpartsList, bookparts) => {
    const items = [];
    let currentListGroup = null;

    bookpartsList.forEach((id) => {
        const part = bookparts[id];
        const isListLinePart = isListTextPart(part) || isListPausePart(part);
        const listItemKey = getListItemKey(part);

        if (!isListLinePart || !listItemKey) {
            if (currentListGroup) {
                items.push(currentListGroup);
                currentListGroup = null;
            }

            items.push({ type: 'part', id });
            return;
        }

        if (!currentListGroup || currentListGroup.key !== listItemKey) {
            if (currentListGroup) {
                items.push(currentListGroup);
            }

            currentListGroup = {
                type: 'list-line',
                key: listItemKey,
                listLevel: part.list_level,
                ids: [id],
            };
            return;
        }

        currentListGroup.ids.push(id);
    });

    if (currentListGroup) {
        items.push(currentListGroup);
    }

    return items;
};

export const getListIndentStyle = (listLevel) => {
    if (typeof listLevel !== 'number') return {};

    return {
        marginInlineStart: `${(listLevel + 1) * LIST_INDENT_STEP}px`,
    };
};

export const getBookIdFromBookpart = (bookpart) => {
    if (typeof bookpart.book === 'object') return bookpart.book.id;

    return bookpart.book;
};

// RTL (Right-to-Left) languages
// To add support for a new RTL language, simply add its language code to this array
const RTL_LANGUAGES = ['arabic', 'hebrew'];

/**
 * Check if the given language is RTL (Right-to-Left)
 * @param {string} language - Language code
 * @returns {boolean} - True if language is RTL
 */
export const isRtlLanguage = (language) => {
    if (!language) return false;
    return RTL_LANGUAGES.includes(language.toLowerCase());
};
